export default __webpack_public_path__ + "static/media/16.e0551c13.jpg";